export const getTargetGroup = (value?: string) => {
  if (value === "CBSE" || value === "JNV" || value === "USER_ASKED" || value === "KVS" || value === "INTERNAL") {
    return "CBSE";
  } else if (value === "UP Board") {
    return "UP_Board";
  } else if (value === "Bihar Board") {
    return "Bihar_Board"
  } else {
    return "Others"
  }
}

export const getTargetGroupType = (value?: string) => {
  if (value === "IIT JEE" || value === "FOUNDATION" || value === "") {
    return "IIT_JEE"
  } else if (value === "NEET") {
    return "NEET"
  } else {
    return "Others"
  }
}

export const getSubject = (value?: string) => {
  if (value === "PHYSICS") {
    return value
  } else if (value === "MATHS") {
    return value
  } else if (value === "ENGLISH") {
    return value
  } else if (value === "CHEMISTRY") {
    return value
  } else if (value === "BIOLOGY") {
    return value
  } else {
    return "OTHERS"
  }
}

export const superEncodeURI = (url: any) => {
  let encodedStr = "",
    encodeChars = ["(", ")", ":", "<", ">", "[", "]", "{", "}", "|", "^", ",", "'", '"', "`", "/", "?", "&", "#"];
  url = encodeURI(url);

  for (let i = 0, len = url.length; i < len; i++) {
    if (encodeChars.indexOf(url[i]) >= 0) {
      const hex = parseInt(url.charCodeAt(i)).toString(16);
      encodedStr += `%${hex}`;
    } else {
      encodedStr += url[i];
    }
  }

  return encodedStr;
}


export const checkTextSol = (sol: string) => typeof sol !== "undefined" && sol !== null && sol !== "" && sol !== "N/A" && sol !== "N//A" ? sol?.trim() : "";

export const isEncryptedVideo = (videoName?: string) => {
  return videoName?.split("/").slice(-1)[0]?.split(".")[0]?.length === 32;
}